module.exports = __webpack_public_path__ + "static/media/leandro-almeida.74cba26b.png";